"use client";

declare global {
  interface Window {
    __trackingEventGuards?: Record<string, number>;
  }
}

export function shouldTrackClientEventOnce(
  key: string,
  dedupeWindowMs = 1_500,
): boolean {
  if (typeof window === "undefined") {
    return true;
  }

  const now = Date.now();
  const guards = (window.__trackingEventGuards ??= {});
  const lastTrackedAt = guards[key];

  if (lastTrackedAt && now - lastTrackedAt < dedupeWindowMs) {
    return false;
  }

  guards[key] = now;
  return true;
}
